import { NgModule } from '@angular/core';

import { MasterEdit0Actions } from './master-edit-0.actions';

@NgModule({
  providers: [
    MasterEdit0Actions
  ]
})
export class MasterEdit0ActionsModule {}
